import React from 'react';
import { Field } from 'react-final-form';
import { ImageUpload } from '../FileUpload';

const ImageField = ({ name = 'image', ...restProps }) => (
  <Field name={name} render={({ input }) => <ImageUpload {...input} {...restProps} />} />
);

export default ImageField;
